import React from "react";

export type ColumnSnapperProps = {
  wideColumns: number,
  narrowColumns: number,
  minColumnPixWidth: number,
  children: React.ReactNode
}
      {/* way to simulate container query without using container query 
      to snap between m items per row and n item per
      row, and never any between, without media queries */}
      // <div style={{
      //   display: 'grid',
      //   gridTemplateColumns: 
      //     `repeat(
      //       auto-fill,
      //       minmax(
      //         clamp(
      //           clamp( 100%/(3 + 1) + 0.1%, (600px - 100%)*1000, 100%/(1 + 1) + 0.1% ), 
      //           (100% - 100%)*1000,
      //           100%
      //         ),
      //         1fr
      //       )
      //     )`
      //   }}>
      //   <div className="item bg-pink-500 p-4 text-center">Item 1</div>
      //   <div className="item bg-pink-500 p-4 text-center">Item 2</div>
      //   <div className="item bg-pink-500 p-4 text-center">Item 3</div>
      //   <div className="item bg-pink-500 p-4 text-center">Item 4</div>
      //   <div className="item bg-pink-500 p-4 text-center">Item 5</div>
      //   <div className="item bg-pink-500 p-4 text-center">Item 6</div>
      // </div>

const ColumnSnapper: React.FC<ColumnSnapperProps> = ({ wideColumns, narrowColumns, minColumnPixWidth, children}) => {

  return (

    <div 
      className=""
      style={{
      display: 'grid',
      gridTemplateColumns: 
        `repeat(
          auto-fill,
          minmax(
            clamp(
              clamp(
                100%/(${wideColumns} + 1) + 0.1%, 
                (${minColumnPixWidth}px - 100%)*1000, 
                100%/(${narrowColumns} + 1) + 0.1% 
              ), 
              (100% - 100%)*1000,
              100%
            ),
            1fr
          )
        )`
      }}
    >
      { children }
    </div>
  )
};

export default ColumnSnapper;